export default __webpack_public_path__ + "static/media/report_icon_gray.50e6de3e.svg";